import React from 'react';
import { Link } from 'react-router-dom';
import { BreadcrumbNav, BreadcrumbList, BreadcrumbItem } from './BreadcrumbStyles';
import useBreadcrumbs from '../../hooks/useBreadcrumbs';

const Breadcrumb = () => {
  const breadcrumbs = useBreadcrumbs();

  return (
    <BreadcrumbNav aria-label="breadcrumb">
      <BreadcrumbList>
        {/* Aggiungi Home come elemento iniziale */}
        <BreadcrumbItem>
          <Link to="/">
            <p>Home</p>
          </Link>
        </BreadcrumbItem>

        {/* Renderizza i breadcrumb */}
        {breadcrumbs.map(({ breadcrumb, path }, index) => {
          const isLast = index === breadcrumbs.length - 1;

          return (
            <BreadcrumbItem key={path}>
              {!isLast ? (
                <Link to={path}>
                  <p>{breadcrumb}</p>
                </Link>
              ) : (
                <p>{breadcrumb}</p>
              )}
            </BreadcrumbItem>
          );
        })}
      </BreadcrumbList>
    </BreadcrumbNav>
  );
};

export default Breadcrumb;
